import aliHandler from './platform/1688/handler'
import taoteHandler from './platform/taote/handler'
import Header1688Goods from './components/header/tb_1688/1688_goods'
import Header1688SupportMiwenGoods from './components/header/tb_1688/1688_support_miwen_goods'
import HeaderTaoteGoods from './components/header/taote/taote_goods'
import { markRaw } from 'vue'

const activekeyList = [
  { 
    label: '1688精选货盘',
    value: 'aliKeyword',
    type: 'ali',
    api: aliHandler.SearchGoodsByKeyword,
    list: [],
    selectedList: [],
    categoryList: [],
    params: { 
      total: 0, page: 1, keyword: '', size: 50, poolId: '', catId: []
    },
    pageSizeOptions: ['30', '50'],
    routeKey: 'ali_movingFunction',
    component: markRaw(Header1688Goods),
    apiTag: '1688jx'
  },
  { 
    label: '平台推荐货盘',
    value: 'aliKeyword6',
    type: 'ali',
    api: aliHandler.SearchGoodsBySupply,
    list: [],
    selectedList: [],
    categoryList: [],
    params: { 
      total: 0, page: 1, keyword: '', size: 100, catId: null, sort: null, fhsx: null, 
      minPrice: '', maxPrice: '', type: 3     
    },
    routeKey: 'ali_movingFunction',
    isOnlyFirstCategory: true,
    component: markRaw(Header1688SupportMiwenGoods),
    apiTag: '1688platsuggest'
  },
  { 
    label: '福利品货盘',
    value: 'aliKeyword5',
    type: 'ali',
    api: aliHandler.SearchGoodsBySupply,
    list: [],
    selectedList: [],
    categoryList: [],
    params: { 
      total: 0, page: 1, keyword: '', size: 100, catId: null, sort: null,fhsx: null,
      minPrice: '', maxPrice: '', type: 1
    },
    routeKey: 'ali_movingFunction',
    component: markRaw(Header1688SupportMiwenGoods),
    apiTag: '1688flp'
  },
  { 
    label: '淘特精选货盘',
    value: 'taoteKeyword',
    type: 'taote',
    api: taoteHandler.SearchGoodsByKeyword,
    list: [],
    selectedList: [],
    sortOptions: [
      { value: 4, label: '销量降序' }, { value: 1, label: '价格降序' },
      { value: 2, label: '价格升序' }, { value: 3, label: '综合排序' },
      { value: 7, label: '好评率降序' }, { value: 8, label: '好评率升序' },
      { value: 9, label: '退货率降序' }, { value: 10, label: '退货率升序' },
      { value: 11, label: '发货时效降序' }, { value: 12, label: '发货时效降序' },
      { value: 5, label: '客服响应降序' }, { value: 6, label: '客服响应降序' }
    ],
    lvOptions: [
      { value: 1, label: '优秀' }, { value: 2, label: '良好' }, { value: 3, label: '一般' }
    ],
    params: { 
      total: 0, page: 1, keyword: '', size: 30, sort: null, poolId: '', catId: [],
      minPrice: null, maxPrice: null, refundLv: null, posReviewLv: null, cstLv: null, shipLv: null
    },
    catName: '',
    typeOptions: [],
    categoryList: [],
    visibleCatePopover: false,
    routeKey: 'taote_movingFunction',
    component: markRaw(HeaderTaoteGoods),
    apiTag: 'ttjxhp'
  },
  { 
    label: '平台推荐货盘',
    value: 'taoteKeyword3',
    type: 'taote',
    api: taoteHandler.SearchGoodsByJx,
    list: [],
    selectedList: [],
    sortOptions: [
      { value: '', label: '默认排序' },
      { value: 'Price', label: '价格升序' },
      { value: '-Price', label: '价格降序' }
    ],
    params: { 
      total: 0, page: 1, keyword: '', size: 100, sort: null, poolId: '', catId: null
    },
    catName: '',
    categoryList: [],
    typeOptions: [],
    visibleCatePopover: false,
    routeKey: 'taote_movingFunction',
    component: markRaw(HeaderTaoteGoods),
    goodsType: 'gyl',
    isOnlyFirstCategory: true,
    apiTag: 'ttpttj'
  },
  {
    label: '福利品货盘',
    value: 'taoteKeyword2',
    type: 'taote',
    api: taoteHandler.SearchGoodsByKeyword,
    list: [],
    selectedList: [],
    sortOptions: [
      { value: 4, label: '销量降序' }, { value: 1, label: '价格降序' },
      { value: 2, label: '价格升序' }, { value: 3, label: '综合排序' },
      { value: 7, label: '好评率降序' }, { value: 8, label: '好评率升序' },
      { value: 9, label: '退货率降序' }, { value: 10, label: '退货率升序' },
      { value: 11, label: '发货时效降序' }, { value: 12, label: '发货时效降序' },
      { value: 5, label: '客服响应降序' }, { value: 6, label: '客服响应降序' }
    ],
    lvOptions: [
      { value: 1, label: '优秀' }, { value: 2, label: '良好' }, { value: 3, label: '一般' }
    ],
    params: { 
      total: 0, page: 1, keyword: '', size: 30, sort: null, poolId: '', catId: [],
      minPrice: null, maxPrice: null, refundLv: null, posReviewLv: null, cstLv: null, shipLv: null
    },
    catName: '',
    typeOptions: [],
    categoryList: [],
    visibleCatePopover: false,
    lowPriceFlow: 1011,
    routeKey: 'taote_movingFunction',
    component: markRaw(HeaderTaoteGoods),
    isOnlyFirstCategory: true,
    apiTag: 'ttflp'
  }
]

export default { activekeyList }